import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },

    root: {
      border: '1px solid #D2D2D2',
      borderRadius: 6,
      padding: theme.spacing(2, 1.5, 1),
      flex: 1,

      '& > header': {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),

        marginBottom: theme.spacing(2),

        '& > h3': {
          fontSize: '1.6rem',
        },

        '& > div': {
          display: 'flex',
          justifyContent: 'space-between',

          '& .MuiTypography-subtitle1': {
            lineHeight: '1.6rem',
          },

          '& > svg': {
            width: '1.6rem',
            color: '#727970',
          },
        },
      },

      '& > ul': {
        margin: 0,
        padding: 0,

        '& > li + li': {
          marginTop: '1.6rem',
        },
      },
    },

    cardInfo: {
      backgroundColor: '#EFF6ED',
      borderRadius: 4,
      border: '1px solid #006E2C',
      marginTop: '1rem',
      display: 'flex',
      alignItems: 'flex-start',
      padding: '1.6rem 1rem',
      gap: '1rem',
      '& span': {
        paddingTop: '0.5rem',
        fontSize: '1.6rem',
      },
      '& .MuiTypography-subtitle1': {
        fontSize: '1.2rem',
        lineHeight: '1.6rem',
      },
      '& > div': {
        display: 'flex',
        flexDirection: 'column',
        '& > div': {
          gap: '0.5rem',
          display: 'flex',
          '& .MuiTypography-subtitle2': {
            fontSize: '1.2rem',
          },
        },
      },
    },
    linkInfo: {
      display: 'flex',
      alignItems: 'center',
      borderBottom: '1px solid #006E2C',
      fontSize: '1.2rem',
      '& .MuiTypography-subtitle2': {
        color: '#006E2C',
      },
      '& > svg': {
        fontSize: '1.4rem',
        color: '#006E2C',
      },
    },

    buttonContainer: {
      margin: '1rem 0',

      display: 'flex',
      gap: '1.2rem',

      '& button': {
        width: '100%',
        height: '3.6rem',
        margin: 0,

        gap: '1rem',
      },
    },
  }),
)
